<div *ngIf="logged then UnifersaBlock else LoginBlock"></div>

<ng-template #UnifersaBlock>
    <router-outlet></router-outlet>
</ng-template>

<ng-template #LoginBlock>
    <router-outlet></router-outlet>
</ng-template>